import { css, html, TemplateResult, CSSResult } from "lit";

export default class OlComponent {
    styles: CSSResult = css``;

    render(): TemplateResult<1> {
        return html``
    }
}